// SettingsSidebar.js
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import { ArrowBack, AccountCircle, Gavel, Block, LockOpen } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

const SettingsSidebar = ({ isAdmin }) => {
    // console.log("SettingsSidebar - isAdmin:", isAdmin); // Debugging log
    const location = useLocation();
    const [hovered, setHovered] = useState(null);

    // Apply active and hover styles
    const getItemStyle = (path) => ({
        color: location.pathname === path || hovered === path ? 'var(--deepPurple-700, #512DA8)' : 'rgba(0, 0, 0, 0.87)',
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0.15px',
        backgroundColor: location.pathname === path || hovered === path ? 'var(--deepPurple-50, #EDE7F6)' : 'transparent',
        padding: '10px',
        transition: 'background-color 0.2s ease-in-out, color 0.2s ease-in-out',
    });

    const getIconStyle = (path) => ({
        color: location.pathname === path || hovered === path ? 'var(--deepPurple-700, #512DA8)' : 'rgba(0, 0, 0, 0.56)',
        fontSize: '24px',
        fontWeight: 400,
        transition: 'color 0.2s ease-in-out',
    });

    return (
        <Drawer
            variant='permanent'
            sx={{
                width: 240,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: 240,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                },
            }}
        >
            <Box>
                <List sx={{ paddingTop: '0px' }}>
                    {/* Back to Application Tracker */}
                    <ListItem
                        component={Link}
                        to='/'
                        sx={getItemStyle('/')}
                        onMouseEnter={() => setHovered('/')}
                        onMouseLeave={() => setHovered(null)}
                    >
                        <ListItemIcon>
                            <ArrowBack style={getIconStyle('/')} />
                        </ListItemIcon>
                        <ListItemText primary='Back to Application Tracker' />
                    </ListItem>

                    {/* Account always visible */}
                    <ListItem
                        component={Link}
                        to='/settings'
                        sx={getItemStyle('/settings')}
                        onMouseEnter={() => setHovered('/settings')}
                        onMouseLeave={() => setHovered(null)}
                    >
                        <ListItemIcon>
                            <AccountCircle style={getIconStyle('/settings')} />
                        </ListItemIcon>
                        <ListItemText primary='Account' />
                    </ListItem>

                    {/* Admin-only sections */}
                    {isAdmin && (
                        <>
                            <ListItem
                                component={Link}
                                to='/settings/admin-users'
                                sx={getItemStyle('/settings/admin-users')}
                                onMouseEnter={() => setHovered('/settings/admin-users')}
                                onMouseLeave={() => setHovered(null)}
                            >
                                <ListItemIcon>
                                    <Gavel style={getIconStyle('/settings/admin-users')} />
                                </ListItemIcon>
                                <ListItemText primary='Approve Users' />
                            </ListItem>

                            <ListItem
                                component={Link}
                                to='/settings/locked-users'
                                sx={getItemStyle('/settings/locked-users')}
                                onMouseEnter={() => setHovered('/settings/locked-users')}
                                onMouseLeave={() => setHovered(null)}
                            >
                                <ListItemIcon>
                                    <LockOpen style={getIconStyle('/settings/locked-users')} />
                                </ListItemIcon>
                                <ListItemText primary='Locked Users' />
                            </ListItem>

                            <ListItem
                                component={Link}
                                to='/settings/banned-users'
                                sx={getItemStyle('/settings/banned-users')}
                                onMouseEnter={() => setHovered('/settings/banned-users')}
                                onMouseLeave={() => setHovered(null)}
                            >
                                <ListItemIcon>
                                    <Block style={getIconStyle('/settings/banned-users')} />
                                </ListItemIcon>
                                <ListItemText primary='Blocked Users' />
                            </ListItem>
                        </>
                    )}
                </List>
            </Box>
        </Drawer>
    );
};

export default SettingsSidebar;